import classNames from 'classnames'
import React, { CSSProperties } from 'react'

const BG_IMAGE = `url('data:image/svg+xml;charset=UTF-8, <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 211.5 194"><path fill="%23E6E6E6" d="M39.2 16.2L6.5 72.8c-8.7 15-8.7 33.5 0 48.5l32.7 56.6c5.8 10 16.5 16.2 28 16.2h65.3c17.3 0 33.3-9.2 42-24.3l32.7-56.6c5.8-10 5.8-22.3 0-32.3l-32.7-56.6c-8.7-15-24.7-24.3-42-24.3H67.2c-11.6 0-22.3 6.2-28 16.2zm28-5.4l130.7 75.5v21.6L67.2 183.2l-18.7-10.8V21.5l18.7-10.7z" /></svg>')`

export type Shade = 'light' | 'normal' | 'dark' | 'light-on-dark-bg'

type BorderRadius = 0 | 2 | 4 | 8

type Props = {
  width?: number
  height?: number
  shade?: Shade
  borderRadius?: BorderRadius
  className?: string
  square?: boolean
  withLogo?: boolean
  noAnimation?: boolean
  children?: React.ReactNode
}

export const Skeleton = ({
  width,
  height,
  shade = 'normal',
  borderRadius = 4,
  className,
  square = false,
  withLogo = false,
  noAnimation = false,
  children,
}: Props) => {
  const bgClass = withLogo
    ? 'u-bg-center'
    : {
        light: 'u-bg-white',
        normal: 'u-bg-gray-02-opacity',
        dark: 'u-bg-gray-03-opacity',
        'light-on-dark-bg': 'u-bg-white-opacity-29',
      }[shade]

  const radiusClass = {
    0: 'u-radius-0',
    2: 'u-radius-2',
    4: 'u-radius-4',
    6: 'u-radius-6',
    8: 'u-radius-8',
  }[borderRadius]

  const style: CSSProperties = {
    //TODO: this causes hydration issues
    ...(square
      ? {
          height: 0,
          paddingTop: '100%',
        }
      : {
          height: typeof height === 'number' ? `${height}px` : 'auto',
        }),
    width: width ? `${width}px` : '100%',
    backgroundImage: withLogo ? BG_IMAGE : 'none',
    backgroundSize: '80% 76%',
  }

  return (
    <>
      <div
        className={classNames('u-overflow-hidden u-w-max-100', bgClass, radiusClass, className, {
          'a-pulse': !noAnimation,
        })}
        style={style}>
        {children}
      </div>
    </>
  )
}
